import { CompanyPageLoadingState } from '@/components/company/CompanyPageLoadingState';
import { CompanyPageErrorState } from '@/components/company/CompanyPageErrorState';
import { BookingFlow } from '@/components/booking/BookingFlow';
import { useCompanyBySlug } from '@/hooks/queries/useCompanyBySlug';
import type { BookingLocationState } from '@/types/booking-location-state';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const Booking = () => {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const { company, isLoading, isError, refetch } = useCompanyBySlug(slug);
  const locationState = (location.state as BookingLocationState | null) ?? null;

  if (isLoading) return <CompanyPageLoadingState />;
  if (isError || !company) {
    return <CompanyPageErrorState onRetry={() => void refetch()} onGoBack={() => navigate(-1)} />;
  }

  return <BookingFlow company={company} initialState={locationState} variant="standalone" />;
};

export default Booking;
